import createIcon from './utils/createIcon.js';
import '@babel/runtime/helpers/esm/extends';
import 'react';
import './utils/SvgIcon.js';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import 'react-desc';
import '@elliemae/ds-classnames';

/* eslint-disable */
var QueryAdd = createIcon({
  paths: ['M20.5 22h-18c-.2764 0-.5-.2236-.5-.5s.2236-.5.5-.5h18a.501.501 0 00.5-.5v-16c0-.2759-.2246-.5-.5-.5h-18c-.2764 0-.5-.2236-.5-.5s.2236-.5.5-.5h18c.8271 0 1.5.6729 1.5 1.5v16c0 .8271-.6729 1.5-1.5 1.5zm-5-10h-3V9c0-.275-.225-.5-.5-.5s-.5.225-.5.5v3h-3c-.275 0-.5.225-.5.5s.225.5.5.5h3v3c0 .275.225.5.5.5s.5-.225.5-.5v-3h3c.275 0 .5-.225.5-.5s-.225-.5-.5-.5z'],
  height: 24,
  width: 24
});

export default QueryAdd;
//# sourceMappingURL=QueryAdd.js.map
